import { render, staticRenderFns } from "./project_powered_button.vue?vue&type=template&id=3ec342e2&"
import script from "./project_powered_button.vue?vue&type=script&lang=js&"
export * from "./project_powered_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports